<template>
  <v-row class="center-content">
    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
      <v-card flat>
        <!-- <v-card-title>
          <div class="panel-right-options ml-auto d-flex">
            <div class="filter-btn-main">
              <v-row justify="center">
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on: dialog }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <v-icon
                          large
                          color="white"
                          class="pr-2"
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...dialog }"
                        >
                          mdi-filter-outline
                        </v-icon>
                      </template>
                      <span>Filter</span>
                    </v-tooltip>
                  </template>
                  <div class="filters-bx">
                    <v-card class="dialog-cls">
                      <div class="filters-dialog">
                        <v-card-title class="header-title">
                          SELECT FILTERS
                          <v-spacer></v-spacer>
                          <v-icon
                            class="vuetify-icon"
                            @click="dialog = false"
                            color="white"
                            >close</v-icon
                          >
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="scroll-box">
                          <v-subheader class="dialog-sub-title"
                            >STANDARD</v-subheader
                          >
                          <v-radio-group
                            v-model="standard"
                            row
                            class="ml-5 dialog-text"
                          >
                            <v-radio label="New" value="new"></v-radio>
                            <v-radio label="Popular" value="popular"></v-radio>
                            <v-radio
                              label="Trending"
                              value="trending"
                            ></v-radio>
                          </v-radio-group>
                          <v-subheader class="dialog-sub-title"
                            >CATEGORY</v-subheader
                          >
                          <v-treeview
                            :items="newsCategoryList"
                            :selection-type="selectionType"
                            selectable
                            v-model="category"
                            item-children="childs"
                            item-key="_id"
                            class="dialog-text"
                          ></v-treeview>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="#344452" dark @click="search"
                            >Filter</v-btn
                          >
                          <v-btn color="gray" @click="resetFilter">Clear</v-btn>
                        </v-card-actions>
                      </div>
                    </v-card>
                  </div>
                </v-dialog>
              </v-row>
            </div>
          </div>
        </v-card-title> -->
        <v-card-text class="pt-0">
          <div class="dialog-cls">
            <v-row class="ma-0">
              <v-col
                cols="8"
                v-if="$vuetify.breakpoint.smAndUp"
                :class="{ 'px-0': $vuetify.breakpoint.smOnly }"
                class="d-flex align-center"
              >
                <h4 class="px-1 page-header-title text-capitalize">
                  Discover Latest News & Articles
                </h4>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
                class="px-0"
              >
                <v-text-field
                  v-model.trim="searchVal"
                  v-debounce:1s="search"
                  solo
                  append-icon="mdi-magnify"
                  :label="
                    $vuetify.breakpoint.smAndUp
                      ? 'Discover news & articles'
                      : 'Discover media'
                  "
                  hide-details
                  clearable
                  class="search-message-input"
                  :debounce-events="['click', 'keyup', 'keydown']"
                  @click:clear="clearSearch()"
                />
              </v-col>
              <v-col
                cols="12"
                class="pb-0"
                style="border-bottom: 1px solid lightgrey"
              >
                <v-tabs v-model="tab">
                  <v-tabs-slider class="tabs-slider"></v-tabs-slider>
                  <v-tab
                    class="tabs-title"
                    v-for="(item, i) in newsCategoryList"
                    :key="i"
                    @click="onTabChange(item)"
                  >
                    {{ item.name }}
                  </v-tab>
                </v-tabs>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.smAndUp ? 6 : 12"
                class="px-4 pb-0 d-flex align-center"
              >
                <h4 class="page-header-title text-capitalize">Most recent</h4>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.smAndUp ? 6 : 12"
                class="py-0"
                :class="{
                  'px-0 pb-0 d-flex align-center align-end justify-end':
                    $vuetify.breakpoint.smAndUp
                }"
              >
                <v-radio-group
                  v-model="standard"
                  class="dialog-text"
                  style="font-size:12px;"
                  @change="search"
                  row
                >
                  <!-- <v-radio label="New" value="new"></v-radio> -->
                  <v-radio label="Popular" value="popular"></v-radio>
                  <v-radio label="Trending" value="trending"></v-radio>
                </v-radio-group>
                <v-btn
                  :disabled="clearFilterDisable"
                  text
                  color="red"
                  class="text-transform"
                  :class="{ 'px-0 float-right': $vuetify.breakpoint.smAndDown }"
                  @click="resetFilter"
                  >Clear filters</v-btn
                >
                <!-- <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on: dialog }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <v-icon
                          size="30"
                          color="lightgrey"
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...dialog }"
                        >
                          mdi-filter-outline
                        </v-icon>
                      </template>
                      <span>Filter</span>
                    </v-tooltip>
                  </template>
                  <div class="filters-bx">
                    <v-card class="dialog-cls">
                      <div class="filters-dialog">
                        <v-card-title class="header-title">
                          SELECT FILTERS
                          <v-spacer></v-spacer>
                          <v-icon
                            class="vuetify-icon"
                            @click="dialog = false"
                            color="white"
                            >close</v-icon
                          >
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="scroll-box">
                          <v-radio-group
                            v-model="standard"
                            class="ml-5 dialog-text"
                          >
                            <v-radio label="New" value="new"></v-radio>
                            <v-radio label="Popular" value="popular"></v-radio>
                            <v-radio
                              label="Trending"
                              value="trending"
                            ></v-radio>
                          </v-radio-group> -->
                <!-- <v-subheader class="dialog-sub-title"
                            >CATEGORY</v-subheader
                          >
                          <v-treeview
                            :items="newsCategoryList"
                            :selection-type="selectionType"
                            selectable
                            v-model="category"
                            item-children="childs"
                            item-key="_id"
                            class="dialog-text"
                          ></v-treeview> -->
                <!-- </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="#344452" dark @click="search"
                            >Filter</v-btn
                          >
                          <v-btn color="gray" @click="resetFilter">Clear</v-btn>
                        </v-card-actions>
                      </div>
                    </v-card>
                  </div>
                </v-dialog> -->
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="3"
                    lg="3"
                    xl="3"
                    v-for="item in newsFeedList"
                    :key="item._id"
                    class="pa-3"
                  >
                    <list-view
                      :newsFeed="item"
                      @categoryClicked="categoryClick"
                    ></list-view>
                  </v-col>
                  <v-col cols="12">
                    <infinite-loading
                      :identifier="infiniteId"
                      @infinite="infiniteHandler"
                    >
                      <div slot="spinner">
                        <v-row>
                          <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="3"
                            lg="3"
                            xl="3"
                            v-for="n in 12"
                            :key="n"
                          >
                            <v-skeleton-loader
                              ref="skeleton"
                              :boilerplate="boilerplate"
                              type="card-avatar, article"
                              class="mx-auto"
                            ></v-skeleton-loader>
                          </v-col>
                        </v-row>
                      </div>
                      <div slot="no-more"></div>
                      <div slot="no-results" class="no-results">
                        <v-card elevation="0">
                          <v-card-title class="dialog-title-sm">
                            <v-spacer></v-spacer>
                            <strong>Sorry 😞</strong>, we couldn't find any
                            results.
                            <v-spacer></v-spacer>
                          </v-card-title>
                        </v-card>
                      </div>
                    </infinite-loading>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { NewsFeedService } from "@/services";
import { mapGetters } from "vuex";
export default {
  name: "NewsFeed",
  components: {
    InfiniteLoading,
    ListView: () => import("./List")
  },
  data() {
    return {
      boilerplate: false,
      newsCategoryList: [],
      newsFeedList: [],
      standard: "",
      category: [],
      infiniteId: +new Date(),
      page: 1,
      perPage: 12,
      dialog: false,
      selectionType: "independent",
      query: {},
      tab: null,
      searchVal: null,
      searchLoading: false
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  async mounted() {
    const categoryList = await NewsFeedService.getCategoryList();
    this.newsCategoryList = categoryList.data;
    this.newsCategoryList.unshift({
      _id: "all",
      name: "All"
    });
    this.checkQuery();
  },
  computed: {
    ...mapGetters("user", {
      isUserLoggedIn: "isUserLoggedIn"
    }),
    clearFilterDisable() {
      return this.standard ? false : true;
    }
  },
  methods: {
    async infiniteHandler($state) {
      if (this.$route.query) {
        if (this.$route.query.category && this.$route.query.category.length) {
          this.category = this.$route.query.category;
        }
        if (this.$route.query.standard) {
          this.standard = this.$route.query.standard;
        }
      }
      if (this.searchVal !== "") this.searchLoading = true;
      const params = {
        category: this.category,
        trending: this.standard === "trending",
        popular: this.standard === "popular",
        limit: parseInt(this.perPage),
        skip:
          parseInt(this.page) * parseInt(this.perPage) - parseInt(this.perPage)
      };
      if (this.searchVal !== "") params.title = this.searchVal;
      const newsfeedList = await NewsFeedService.getNewsFeedList(params);
      if (newsfeedList.data.data.length > 0) {
        this.page += 1;
        this.newsFeedList.push(...newsfeedList.data.data);
        if (newsfeedList.data.option[0].count > this.newsFeedList.length) {
          $state.loaded();
        } else {
          $state.loaded();
          $state.complete();
        }
      } else {
        $state.complete();
      }
      this.searchLoading = false;
    },
    async search() {
      this.query.category = this.category;
      this.query.standard = this.standard;
      this.$router.replace({ query: this.query }).catch(err => {
        err;
      });
      this.dialog = false;
      this.newsFeedList = [];
      this.page = 1;
      this.infiniteId += 1;
    },
    clearSearch() {
      this.searchVal = "";
      delete this.query.name;
      this.newsFeedList = [];
      this.page = 1;
      this.infiniteId += 1;
    },
    onTabChange(val) {
      let query = {
        category: [val._id],
        standard: this.standard
      };
      this.$router.replace({ query: query }).catch(err => {
        err;
      });
    },
    checkQuery() {
      if (this.$route && this.$route.query && this.$route.query.category) {
        let selectedCategory = this.newsCategoryList.find(category => {
          return category._id == this.$route.query.category;
        });
        this.tab = this.newsCategoryList.indexOf(selectedCategory);
      }
    },
    resetFilter() {
      this.standard = "";
      this.category = [];
      delete this.query.standard;
      delete this.query.category;
      this.$router.replace({ query: this.query }).catch(err => {
        err;
      });
    },
    categoryClick(id) {
      this.category = [];
      this.standard = "new";
      this.category.push(id);
      this.search();
    },
    refreshList() {
      this.newsFeedList = [];
      this.page = 1;
      this.infiniteId += 1;
    }
  }
};
</script>

<style scoped lang="scss">
.v-list-item {
  .list-item {
    cursor: pointer;
  }
}
.infinite-status-prompt {
  display: none !important;
}
.dialog-cls {
  .scroll-box {
    max-height: 620px;
    height: 620px;
    // cursor: pointer;
    overflow-y: auto;
  }
}
.filters-bx {
  .dialog-cls {
    .filters-dialog {
      .scroll-box {
        max-height: 200px;
        height: 200px;
        // cursor: pointer;
        overflow-y: auto;
      }
    }
  }
}
.tabs-title {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 27px;
  color: #677c95;
  text-transform: none;
}
.tabs-slider {
  height: 4px;
  bottom: 0px;
  position: absolute;
}
.v-tab--active {
  color: #0c1f36 !important;
}
.page-header-title {
  font-family: "now alt";
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 30px !important;
  color: #0c1f36 !important;
  margin-bottom: 0px !important;
}
.text-transform {
  text-transform: capitalize !important;
  font-size: 16px;
  font-weight: 500;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin: 0px;
}
::v-deep .v-input--radio-group--row .v-input--radio-group__input {
  flex-wrap: nowrap;
}
::v-deep
  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none;
}
</style>
